/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  transactionVolumeListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGet,
} from "../../funcs/transactionVolumeListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$inboundSchema,
};

export const tool$transactionVolumeListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGet:
  ToolDefinition<typeof args> = {
    name:
      "transaction-volume-v1",
    description: `List transaction volume

Original tool name: list-transaction-volume-ledger-canister-id-transaction-volume-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await transactionVolumeListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };